import { Loading01Icon } from '@repo/studio-design-system-ui-icons/general/loading-01'
import { useStudioTranslate } from '@repo/studio-config/studio-config-context'
import { AlertOnlineDotsOnlineBlinking } from '../alert-online-dots'
import { useUsersOnlineCount } from '../../hooks/use-users-online-count'

export function UsersOnline() {
  const usersOnlineCount = useUsersOnlineCount()
  const t = useStudioTranslate()

  return (
    <div className="flex h-[56px] min-w-8 items-center justify-end gap-2 self-end md:min-w-[70px]">
      <AlertOnlineDotsOnlineBlinking />
      {usersOnlineCount === undefined ? (
        <div className="flex items-center justify-center">
          <Loading01Icon className="mr-1 h-3 w-3 animate-spin" />
          <span className="typography-14 flex h-8 items-center text-nowrap">
            {t('studio.flow.online.loading')}
          </span>
        </div>
      ) : (
        <>
          <span className="max-md:hidden typography-14 flex h-8 items-center text-nowrap">
            {t('studio.flow.online', { count: usersOnlineCount })}
          </span>
          <span className="typography-14 flex h-8 items-center text-nowrap md:hidden">
            {usersOnlineCount}
          </span>
        </>
      )}
    </div>
  )
}
